var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { delay } from '../../utilities';
import { fetchJson } from './fetcher/fetcher';
import { getLocationHeader } from './getLocationHeader';
import { mergeHeaders } from './mergeHeaders';
export const DEFAULT_POLLING_HEADERS = {
    accept: 'application/json',
};
export function makePollingRequest({ url, headers, signal, pollingFrequencyMs = 1000, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetchJson(url, {
            headers: mergeHeaders(DEFAULT_POLLING_HEADERS, headers),
            signal,
        });
        // Response is synchronous, so we return the response immediately
        if (response.status === 200) {
            return response;
        }
        const location = getLocationHeader(response);
        yield delay(pollingFrequencyMs);
        return makePollingRequest({
            url: location,
            headers,
            pollingFrequencyMs,
            signal,
        });
    });
}
//# sourceMappingURL=makePollingRequest.js.map